"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'recording.start.failed': '录音启动失败',
};
